// @ts-nocheck
import { graphql, Slice } from "gatsby"
import { useEffect, useState } from "react"
import { Box, useMediaQuery } from "@mui/material"
import { get } from "lodash"
import {
  ContactCTA,
  DynamicSubNav,
  FC,
  Hero,
  TextOverview,
  TripDestinationSearch,
  SubPageHeader,
  AdLandingComponent,
} from "../components"
import SEOHead from "../components/head"
import Layout from "../components/layout"
import {
  useDynamicSubNav,
  useStaffData,
  useGeoPagesSolrData,
  usePromoSolrData,
} from "../local/hooks"

const TripItinerariesSubPageView: FC = (props) => {
  const tripItinerariesSubPage = get(props, "data.nodeSubPage", {})
  const [contactCtaStaff, setContactCtaStaff] = useState(null)
  const [travelInformationPages, setTravelInformationPages] = useState(null)
  const [tripIdeaPages, setTripIdeaPages] = useState(null)
  const [promoData, setPromoData] = useState(null)
  const [utmCampaign, setUtmCampaign] = useState<string | null>(null)
  const { getStaffByDestination } = useStaffData()
  const { getTravelInformationPages, getTripIdeaPages } = useGeoPagesSolrData()
  const { getPromos } = usePromoSolrData()
  const parent = get(tripItinerariesSubPage, "parent_page", null)
  const destinationTitle = get(parent, "destinations[0].title", null)
  const path = get(tripItinerariesSubPage, "slug", null)
  const locationId = get(parent, "external_id", null)
  const parentTitle = get(parent, "title", null)


  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search)
      const campaign = urlParams.get("utm_campaign")
      setUtmCampaign(campaign)
    }
  }, [])

  // Resolve Solr data.
  useEffect(() => {
    const destinationId = get(parent, "destinations[0].external_id", null)
    if (destinationId) {
      getStaffByDestination(destinationId).then((data) => {
        setContactCtaStaff(data)
      })
    }
    if (parent?.external_id) {
      // get trip idea links
      getTripIdeaPages(parent.external_id).then((data) => {
        setTripIdeaPages(data)
      })
      // get travel information links
      getTravelInformationPages(parent.external_id).then((data) => {
        setTravelInformationPages(data)
      })
    }
  }, [])

  useEffect(() => {
    // get promo data
    if (utmCampaign && parent.external_id) {
      getPromos(parent.external_id, utmCampaign).then((data) => {
        setPromoData(data)
      })
    }
  }, [utmCampaign, parent.external_id])

  const subNav = useDynamicSubNav({
    title: parent?.title || "Overview",
    uri: parent?.link?.uri || "#",
    nid: parent?.external_id,
  })

  if (!tripItinerariesSubPage) {
    return <Box>{"Vacation Packages not found"}</Box>
  }

  const getBreadcrumbs = () => {
    const breadcrumbs = [
      {
        title: "Home",
        uri: "/",
      },
      {
        title: "Destinations",
        uri: "/destinations",
      },
    ]

    if (tripItinerariesSubPage?.parent_page?.destinations?.[0]) {
      breadcrumbs.push({
        title: tripItinerariesSubPage?.parent_page?.destinations?.[0]?.title,
        uri: tripItinerariesSubPage?.parent_page?.destinations?.[0]?.slug,
      })
    }

    if (tripItinerariesSubPage?.parent_page) {
      breadcrumbs.push({
        title: tripItinerariesSubPage?.parent_page?.title,
        uri: tripItinerariesSubPage?.parent_page?.link?.uri,
      })
    }

    breadcrumbs.push({
      title: "Vacation Packages",
    })

    return breadcrumbs
  }

  return (
    <>
      {ComposeHead(props)}
      <Layout showChatButton={false}>
        {/* {subNav && (
            <DynamicSubNav
              links={subNav}
              travelInformation={travelInformationPages}
              tripIdea={tripIdeaPages}
              countryId={locationId}
              activeLink={"Vacation Packages"}
            />
        )} */}
        <SubPageHeader
          title={tripItinerariesSubPage.hero.title}
          description={tripItinerariesSubPage.hero.description}
          breadcrumbs={getBreadcrumbs()}
        />
        {promoData && (promoData.title && promoData.body) && (
          <AdLandingComponent
            title={promoData?.title}
            body={promoData?.body}
            photo={tripItinerariesSubPage.hero.images[0]}
          />
        )}
        <TripDestinationSearch location={locationId} path={path} />
        <ContactCTA
          title={tripItinerariesSubPage.template.contact_cta?.title}
          subtitle={tripItinerariesSubPage.template.contact_cta?.subtitle}
          description={tripItinerariesSubPage.template.contact_cta?.description}
          link={tripItinerariesSubPage.template.contact_cta?.link}
          image={tripItinerariesSubPage.template.contact_cta?.image}
          staff={contactCtaStaff}
        />
        <Slice alias="preFooterStyle1" destinationId={destinationTitle} />
      </Layout>
    </>
  )
}

export default TripItinerariesSubPageView

export const ComposeHead = (props) => {
  const { nodeSubPage } = props.data
  const metatag = get(nodeSubPage, "metatag.items")
  const url = get(nodeSubPage, "slug")
  const image = get(nodeSubPage, "hero.images[0].variants[0].url")
  return <SEOHead metas={metatag} url={url} image={image} />
}

export const query = graphql`
  query TripItinerariesSubPageQuery($id: String!) {
    nodeSubPage(id: { eq: $id }) {
      title
      id
      external_id
      metatag {
        items {
          content
          name
        }
      }
      parent_page {
        ...GeoCountryReferenceFragment
      }
      template {
        id
        ... on paragraph__trip_itineraries {
          id
          text_overview {
            title
            subtitle
            description
            layout
          }
          contact_cta {
            ...ContactCtaFragment
          }
        }
      }
      id
      slug
      hero {
        ...HeroFragment
      }
      parent_page {
        title
      }
    }
  }
`
